import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 16h.01","key":"svg-0"}],["path",{"d":"M4 16c9.5 -4 11.5 -8 14 -9","key":"svg-1"}],["path",{"d":"M12 8l5 3","key":"svg-2"}]]

/**
 * IconCurrencyRufiyaa
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktcnVmaXlhYSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjAgMTZoLjAxIiAvPgogIDxwYXRoIGQ9Ik00IDE2YzkuNSAtNCAxMS41IC04IDE0IC05IiAvPgogIDxwYXRoIGQ9Ik0xMiA4bDUgMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-rufiyaa
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyRufiyaa = createReactComponent('outline', 'currency-rufiyaa', 'CurrencyRufiyaa', __iconNode);

export default IconCurrencyRufiyaa;